const degree = [{
  path: 'degree/index',
  component: resolve => require(['../../../../components/pages/studentspace/degree'], resolve)
}, {
  path: 'degree/student/:degreeBatchId',
  component: resolve => require(['../../../../components/pages/studentspace/degree/StudentManagement'], resolve)
}, {
  path: 'degree/school/:degreeBatchId',
  component: resolve => require(['../../../../components/pages/studentspace/degree/GraduateSchool'], resolve)
}, {
  path: 'degree/performance/:degreeBatchId',
  component: resolve => require(['../../../../components/pages/studentspace/degree/CoursePerformance'], resolve)
}, {
  path: 'degree/thesis/:degreeBatchId',
  component: resolve => require(['../../../../components/pages/studentspace/degree/GraduationThesis'], resolve)
}, {
  path: 'degree/english/:degreeBatchId',
  component: resolve => require(['../../../../components/pages/studentspace/degree/DegreeEnglish'], resolve)
}, {
  path: 'degree/application/:degreeBatchId',
  component: resolve => require(['../../../../components/pages/studentspace/degree/DegreeApplication'], resolve)
}, {
  path: 'degree/addCourse/:degreeBatchId',
  component: resolve => require(['../../../../components/pages/studentspace/degree/AddCoursePerformance'], resolve)
}, {
  path: 'degree/addPractice/:degreeBatchId',
  component: resolve => require(['../../../../components/pages/studentspace/degree/AddPracticePerformance'], resolve)
}, {
  path: 'degree/applyState/:degreeBatchId',
  component: resolve => require(['../../../../components/pages/studentspace/degree/DegreeApplyState'], resolve)
}]
export default degree



// WEBPACK FOOTER //
// ./src/router/pages/studentspace/degree/index.js